import { Injectable } from '@angular/core';
import {Local} from 'protractor/built/driverProviders';

@Injectable({
  providedIn: 'root'
})
export class StoreFsrhDetailsService {
  private _formResult1: number;
  private _formResult2: number;
  private _pregnancyTestAdvised: boolean;
  private _oralECUnlikelyEffective: boolean;
  private _offerQuickStartContraception: boolean;
  private _eligibleForCuIUD: boolean;
  private _takingEnzymeInducer: boolean;
  private _asthmaManagedWithglucocorticoids: boolean;
  private _bmi: number;
  private _weightInKg: number;
  private _patientDets: string;
  private _useOfCuIUD: boolean;
  private _wasPeriodNormal: boolean;
  private _within5DaysAfterOvulation: boolean;
  private _takingPOP: boolean;
  private _takingHormonalMethods: boolean;
  private _takingCOC: boolean;
  private _takingImplant: boolean;
  private _takingDepo: boolean;
  private _takingPatchorRing: boolean;
  private _takingIntrauterine: boolean;
  private _fiveDaysAfterOvulationDate: number;
  private _today: number;
  private _breastFeeding: boolean;
  private _HRT: boolean;

  constructor() {
    // this.pregnancyTestAdvised = false;
    // this.oralECUnlikelyEffective = false;
    // this.offerQuickStartContraception = false;
    // this.eligibleForCuIUD = false;
  }

  removeLocalStorageVariables = () => {
    localStorage.removeItem('formResult1');
    localStorage.removeItem('formResult2');
    localStorage.removeItem('pregnancyTestAdvised');
    localStorage.removeItem('oralECUnlikelyEffective');
    localStorage.removeItem('offerQuickStartContraception');
    localStorage.removeItem('eligibleForCuIUD');
    localStorage.removeItem('takingEnzymeInducer');
    localStorage.removeItem('asthmaManagedWithglucocorticoids');
    localStorage.removeItem('bmi');
    localStorage.removeItem('weightInKg');
    localStorage.removeItem('patientDets');
    localStorage.removeItem('useOfCuIUD');
    localStorage.removeItem('wasPeriodNormal');
    localStorage.removeItem('within5DaysAfterOvulation');
    localStorage.removeItem('takingPOP');
    localStorage.removeItem('takingHormonalMethods');
    localStorage.removeItem('takingCOC');
    localStorage.removeItem('takingImplant');
    localStorage.removeItem('takingDepo');
    localStorage.removeItem('takingPatchorRing');
    localStorage.removeItem('takingIntrauterine');
    localStorage.removeItem('fiveDaysAfterOvulationDate');
    localStorage.removeItem('today');
    localStorage.removeItem('breastFeeding');
    localStorage.removeItem('HRT');
  }

  get formResult1(): number {
    // return this._formResult;
    return parseInt(localStorage.getItem('formResult1'), 0);
  }
  get formResult2(): number {
    // return this._formResult;
    return parseInt(localStorage.getItem('formResult2'), 0);
  }

  get pregnancyTestAdvised(): boolean {
    // return this._pregnancyTestAdvised;
    return (localStorage.getItem('pregnancyTestAdvised') === 'true');
  }

  get oralECUnlikelyEffective(): boolean {
    // return this._oralECUnlikelyEffective;
    return (localStorage.getItem('oralECUnlikelyEffective') === 'true');
  }

  get offerQuickStartContraception(): boolean {
    // return this._offerQuickStartContraception;
    return (localStorage.getItem('offerQuickStartContraception') === 'true');
  }

  get eligibleForCuIUD(): boolean {
    // return this._eligibleForCuIUD;
    return (localStorage.getItem('eligibleForCuIUD') === 'true');
  }

  get takingEnzymeInducer(): boolean {
    // return this._takingEnzymeInducer;
    return (localStorage.getItem('takingEnzymeInducer') === 'true');
  }


  get asthmaManagedWithglucocorticoids(): boolean {
    // return this._asthmaManagedWithglucocorticoids;
    return (localStorage.getItem('asthmaManagedWithglucocorticoids') === 'true');
  }

  get bmi(): number {
    // return this._bmi;
    return parseInt(localStorage.getItem('bmi'), 0);
  }

  get weightInKg(): number {
    // return this._weightInKg;
    return parseInt(localStorage.getItem('weightInKg'), 0);
  }

  get patientDets(): string {
    // return this._patientDets;
    return (localStorage.getItem('patientDets'));
  }


  get useOfCuIUD(): boolean {
    return (localStorage.getItem('useOfCuIUD') === 'true');
  }

  get wasPeriodNormal(): boolean {
    return (localStorage.getItem('wasPeriodNormal') === 'true');
  }


  get within5DaysAfterOvulation(): boolean {
    return (localStorage.getItem('within5DaysAfterOvulation') === 'true');
  }

  get takingPOP(): boolean {
    return (localStorage.getItem('takingPOP') === 'true');
  }

  get takingHormonalMethods (): boolean {
    return (localStorage.getItem('takingHormonalMethods') === 'true');
  }
  get takingCOC (): boolean {
    return (localStorage.getItem('takingCOC') === 'true');
  }
  get takingImplant (): boolean {
    return (localStorage.getItem('takingImplant') === 'true');
  }
  get takingDepo (): boolean {
    return (localStorage.getItem('takingDepo') === 'true');
  }
  get takingPatchorRing (): boolean {
    return (localStorage.getItem('takingPatchorRing') === 'true');
  }
  get takingIntrauterine (): boolean {
    return (localStorage.getItem('takingIntrauterine') === 'true');
  }

  get fiveDaysAfterOvulationDate () : number {
    return parseInt(localStorage.getItem('fiveDaysAfterOvulationDate'));
  }
  get today () : number {
    return parseInt(localStorage.getItem('today'));
  }
  get breastFeeding () : boolean {
    return (localStorage.getItem('breastFeeding') === 'true');
  }
  get HRT () : boolean {
    return (localStorage.getItem('HRT') === 'true');
  }


  set formResult1(value: number) {
    this._formResult1 = value;
    localStorage.setItem('formResult1', JSON.stringify(value));
  }
  set formResult2(value: number) {
    this._formResult2 = value;
    localStorage.setItem('formResult2', JSON.stringify(value));
  }

  set pregnancyTestAdvised(value: boolean) {
    this._pregnancyTestAdvised = value;
    localStorage.setItem('pregnancyTestAdvised', JSON.stringify(value));
  }

  set oralECUnlikelyEffective(value: boolean) {
    this._oralECUnlikelyEffective = value;
    localStorage.setItem('oralECUnlikelyEffective', JSON.stringify(value));
  }

  set offerQuickStartContraception(value: boolean) {
    this._offerQuickStartContraception = value;
    localStorage.setItem('offerQuickStartContraception', JSON.stringify(value));
  }

  set eligibleForCuIUD(value: boolean) {
    this._eligibleForCuIUD = value;
    localStorage.setItem('eligibleForCuIUD', JSON.stringify(value));
  }

  set takingEnzymeInducer(value: boolean) {
    this._takingEnzymeInducer = value;
    localStorage.setItem('takingEnzymeInducer', JSON.stringify(value));
  }

  set asthmaManagedWithglucocorticoids(value: boolean) {
    this._asthmaManagedWithglucocorticoids = value;
    localStorage.setItem('asthmaManagedWithglucocorticoids', JSON.stringify(value));
  }

  set bmi(value: number) {
    this._bmi = value;
    localStorage.setItem('bmi', JSON.stringify(value));
  }

  set weightInKg(value: number) {
    this._weightInKg = value;
    localStorage.setItem('weightInKg', JSON.stringify(value));
  }

  set patientDets(value: string) {
    this._patientDets = value;
    // localStorage.setItem('patientDets', value);
  }


  set useOfCuIUD(value: boolean) {
    this._useOfCuIUD = value;
    localStorage.setItem('useOfCuIUD', JSON.stringify(value));
  }

  set wasPeriodNormal(value: boolean) {
    this._wasPeriodNormal = value;
    localStorage.setItem('wasPeriodNormal', JSON.stringify(value));
  }

  set within5DaysAfterOvulation(value: boolean) {
    this._within5DaysAfterOvulation = value;
    localStorage.setItem('within5DaysAfterOvulation', JSON.stringify(value));
  }

  set takingPOP(value: boolean) {
    this._takingPOP = value;
    localStorage.setItem('takingPOP', JSON.stringify(value));
  }

  set takingCOC(value: boolean) {
    this._takingCOC = value;
    localStorage.setItem('takingCOC', JSON.stringify(value));
  }

  set takingHormonalMethods(value: boolean) {
    this._takingHormonalMethods = value;
    localStorage.setItem('takingHormonalMethods', JSON.stringify(value));
  }
  set takingImplant(value: boolean) {
    this._takingImplant = value;
    localStorage.setItem('takingImplant', JSON.stringify(value));
  }
  set takingDepo(value: boolean) {
    this._takingDepo = value;
    localStorage.setItem('takingDepo', JSON.stringify(value));
  }
  set takingPatchorRing(value: boolean) {
    this._takingPatchorRing = value;
    localStorage.setItem('takingPatchorRing', JSON.stringify(value));
  }
  set takingIntrauterine(value: boolean) {
    this._takingIntrauterine = value;
    localStorage.setItem('takingIntrauterine', JSON.stringify(value));
  }
  set fiveDaysAfterOvulationDate(value: number) {
    this._fiveDaysAfterOvulationDate = value;
    localStorage.setItem('fiveDaysAfterOvulationDate', JSON.stringify(value));
  }
  set today(value: number) {
    this._today = value;
    localStorage.setItem('today', JSON.stringify(value));
  }
  set breastFeeding(value: boolean) {
    this._breastFeeding = value;
    localStorage.setItem('breastFeeding', JSON.stringify(value));
  }
  set HRT(value: boolean) {
    this._HRT = value;
    localStorage.setItem('HRT', JSON.stringify(value));
  }


}
